var _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-stroke",
    d: "m56.2,39.57c0-10.61-8.6-19.2-19.2-19.2s-19,8.81-21.02,19.2",
    fill: "none",
    strokeWidth: "6.34px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "wasm-icon-fill wasm-icon-stroke",
    points: "11.59 44.81 29.97 38.58 7.8 25.78 11.59 44.81",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.49px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconUndo);
export default __webpack_public_path__ + "static/media/SDS_icon_Undo.63141abca42fbe1cbc4f7d98bcd2e98e.svg";
export { ForwardRef as ReactComponent };